import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { Filter, FilterConfigDelegate } from '@shared/ui';

export interface FilterSetEditorInput {
  filters: Filter[];
  delegate: FilterConfigDelegate;
}

@Component({
  selector: 'ts-filter-set-editor',
  templateUrl: './filter-set-editor.component.html',
  styleUrls: ['./filter-set-editor.component.scss'],
  standalone: false,
})
export class FilterSetEditorComponent {
  public readonly form: FormGroup = new FormGroup({
    filterConfigName: new FormControl('', [Validators.required]),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: Readonly<FilterSetEditorInput>,
    private readonly dialogRef: MatDialogRef<FilterSetEditorComponent>
  ) {}

  public submit(): void {
    const name = this.form.value.filterConfigName;
    const filters = this.data.filters;

    if (!!name && name !== '') this.data.delegate.updateFilterConfig(name, filters);

    this.dialogRef.close();
  }

  public cancel(): void {
    this.dialogRef.close();
  }
}
